import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Ethos = ({ content, ethosTitleImage }) => {

    return (
        <div className={styles.ethos}>
            <Chip id="260877" title="初选提名标题图" groupName="中国力量" type="struct">
                <div className={styles.ethosTitle}>
                    <img src={ethosTitleImage} />
                </div>
            </Chip>
            <Chip id="260862" title="初选提名数据列表" groupName="中国力量" type="struct">
                <div className={styles.ethosBox}>
                    {
                        content?.mainData?.map((item, index) => {
                            return (
                                <a href={`https://v.ifeng.com/c/${item?.base64Id}`} key={index} target="_blank" className={styles.ethosItem}>
                                    <img className={styles.ethosItemImg} src={formatImage(item.backgroundImage, 164, 214)} />
                                    <div className={styles.ethosItemTitle}>
                                        {item?.name}
                                    </div>
                                </a>
                            );
                        })
                    }
                   
                </div>
            </Chip>
        </div>
    );
};

Ethos.propTypes = {
    content: PropTypes.array,
    ethosTitleImage: PropTypes.string,
};

export default errorBoundary(Ethos);
